export default [
  {
    path: 'users',
    component: () => import('../views/Users'),
    children: [
      {
        path: '/',
        name: 'users-index',
        component: () => import('../views/Index')
      },
      {
        path: 'create',
        name: 'users-create',
        component: () => import('../views/Create')
      },
      {
        path: ':id/edit',
        name: 'users-edit',
        component: () => import('../views/Edit')
      }
    ]
  }
];
